class Styles {
  private cache: string[] = [];

  loadStyle(href: string): void {
    if (this.cache.indexOf(href) >= 0) {
      return;
    }
    this.cache.push(href);
    const link = document.createElement('link');
    link.href = href;
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }
}

const styles = new Styles();

export default styles;
